import { IPoint } from "./IPoint";
import { IPolygon } from "./IPolygon";

export interface IMapLayers {
  createGpsPolygonLayer: (
    data: IPoint[][],
    id: string,
    callback: (latitude: number, longitude: number) => void,
    currentBenchmarkIndex?: number
  ) => void;
  createRetailMatchPolygonLayer: (
    data: IPolygon[],
    id: string,
    getVolumeAlpha: (externalID: string) => number
  ) => void;
  createScatterplotLayer: (
    scatterplotHomeColor: any[],
    scatterplotWorkColor: any[],
    scatterplotRadius: number,
    scatterplotLineWidth: number,
    scatterplotOpacity: number,
    data: any,
    isHome: boolean
  ) => void;
  createHeatmapLayer: (
    homeGradient: number[][],
    workGradient: number[][],
    heatmapOpacity: number,
    heatmapRadius: number,
    heatmapIntensity: number,
    heatmapThreshold: number,
    data: any,
    isHome: boolean
  ) => void;
  createHexagonLayer: (
    homeGradient: number[][],
    workGradient: number[][],
    hexOpacity: number,
    hexRadius: number,
    hexUpperPercentile: number,
    hexLowerPercentile: number,
    hexCoverage: number,
    data: any,
    isHome: boolean
  ) => void;
}
